import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../../Components/Functions/date.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { useSelector } from "react-redux";
const tableHead = [
  "Sr.",
  "Project",
  "Date of Creation",
  "Site Selection",
  "Actions",
];
const ProjectTrackingTable = ({ PT = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();

  const goToView = (id) => {
    navigate(`/client-project-tracking/view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {PT.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            let hasPendingHandover = item?.taskList?.some(
              (task) =>
                task.taskName === "Project Handover" && task.isUpdated === false
            );
            return (
              <tr
                key={item?.id}
                style={{
                  backgroundColor: hasPendingHandover
                    ? "rgb(12, 166, 120,0.1)"
                    : "transparent", // light green
                }}
              >
                <td>{Index}</td>
                <td>{item?.projectClientName || "N/A"}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>{item?.siteClientName || "N/A"}</td>
                {/* <td>
                  {isCompleted ? (
                    <span className="badge bg-success text-white">Completed</span>
                  ) : (
                    statusText
                  )}
                </td> */}
                <td>
                  <CustomViewButton onClick={() => goToView(item.id)} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectTrackingTable;
